// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3wB4o","errorLogs":"styles_errorLogs__3X0EC"};